// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-box {
  position: absolute;
  top: 40px;
  right: 0;
  width: 280px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 12px;
  z-index: 100;
  color: #333;
}
.notification-box .notification-scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}
.notification-box .notification-scroll-container .notification-item {
  border-bottom: 1px solid #f0f0f0;
}
.notification-box .notification-scroll-container .notification-item:hover {
  background-color: #e2e8f0;
}
.notification-box .notification-scroll-container .notification-item .notif-per-item {
  padding: 6px 12px;
}
.notification-box .notification-scroll-container .notification-item .timestamp {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
.notification-box .notification-scroll-container .notification-item:last-child {
  border-bottom: none;
}
.notification-box h4 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Notifications/Notifications.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGI;EAEE,gCAAA;AAFN;AAGO;EACG,yBAAA;AADV;AAIM;EACC,iBAAA;AAFP;AAOM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AALR;AAQM;EACE,mBAAA;AANR;AAWE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AATJ","sourcesContent":["// src/components/NotificationDropdown.scss\n\n.notification-box {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  width: 280px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  padding: 12px;\n  z-index: 100;\n  color: #333;\n\n  .notification-scroll-container {\n    max-height: 300px; // adjust as needed\n    overflow-y: auto;\n    padding-right: 4px;\n\n    .notification-item {\n      \n      border-bottom: 1px solid #f0f0f0;\n       &:hover {\n          background-color: #e2e8f0;\n        }\n\n      .notif-per-item {\n       padding: 6px 12px;\n      }\n\n\n\n      .timestamp {\n        font-size: 12px;\n        color: #888;\n        margin-top: 4px;\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n\n  h4 {\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 6px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
